
import router from '@/router'
import { defineComponent, onMounted, ref } from 'vue'
export default defineComponent({
    components: {},
    props: {},
    setup() {
        const fiveCoach = (bastketballType) => {
            router.push({
                name: 'five-coach-talent',
                query: {
                    bastketballType,
                },
            })
        }
        const showMessage = (basketballType) => {
            let dataSource = ''
            if (basketballType == 'man_5') {
                dataSource = 'man_5——CBA'
            } else {
                dataSource = 'woman_5——WCBA'
            }
            router.push({
                name: 'five-bastketball-talent',
                query: {
                    basketballType,
                    dataSource,
                },
            })
        }

        const showThreeMessage = (basketballType) => {
            router.push({
                name: 'three-basketball-talent',
                query: {
                    basketballType,
                },
            })
        }

        const getNowFormatDate = () => {
            let date = new Date()
            let seperator1 = '/'
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            let strDate = date.getDate()
            // if (month >= 1 && month <= 9) {
            //     month = '0' + month
            // }
            // if (strDate >= 0 && strDate <= 9) {
            //     strDate = '0' + strDate
            // }
            let currentdate = year + seperator1 + month + seperator1 + strDate
            return currentdate
        }
        return {
            fiveCoach,
            showMessage,
            showThreeMessage,
            getNowFormatDate,
        }
    },
})
